module.exports = __webpack_public_path__ + "img/03.2688bcec.png";